export const en = {
    translation: {
        dateformat: "MM/DD/yyyy",
        datepickerFormat: "MM/dd/yyyy",
        dateTimeFormat: "MM/DD/yyyy h:mm A"
    }
}